import { connect } from 'react-redux'
import { emptyObj } from 'util/objects'
import { selectRatingsByMessageId } from 'selectors/ratings'
import './styles.less'

const Rating = connect((initialState, initialProps) => state => {
  const rating =
    selectRatingsByMessageId(state)[initialProps.messageChangeId] || emptyObj
  return {
    grade: rating.grade,
    feedback: rating.feedback,
  }
})(({ grade, feedback }) => {
  if (!grade) return null
  return (
    <div className="rating">
      <div className={`grade ${grade}`}>{`Rated ${grade}`}</div>
      {feedback && <div className="feedback">{feedback}</div>}
    </div>
  )
})

export default Rating
